export class PriFieldEntity{
    id:number;
    name:string;
    code:string;
    position:number;
    labelId:number;
    automatic:boolean;
    manual:boolean;
    active:boolean;
    validation:string;
    constructor(){}
}